import { SLICER_KEYS } from 'types/services';
import { createSlice } from '@reduxjs/toolkit';
import { isMobileApp } from 'utils/common';
import { setColors } from './reducers/setColors';
import { setOverview } from './reducers/setOverview';
import { setEmail } from './reducers/setEmail';
import { setOpenMenu } from './reducers/setOpenMenu';
import { closeMenu } from './reducers/closeMenu';

export interface DashboardState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overview: any; //TODO
  colors: Record<string, string> | null;
  email: string | null;
  menuOpened: boolean;
}

const initialState = {
  overview: null,
  colors: null,
  email: null,
  menuOpened: !isMobileApp(),
};

export const dashboardState = createSlice({
  name: SLICER_KEYS.DASHBOARD,
  initialState,
  reducers: {
    setColors,
    setEmail,
    setOverview,
    setOpenMenu,
    closeMenu,
  },
});

export const dashboardStateActions = dashboardState.actions;
